<!-- タイトルバー メインカラー -->
<template>
  <div class="crly-a-common-btn-side-menu-toggle">
    <div @click.stop="clickToggle">
      {{ title }}
      <span class="batch" v-if="unreadCount > 0">{{ unreadCount }}</span>
    </div>
    <div class="toggle" @click="openToggle" :class="{ open: isOpen }"></div>
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonBtnSideMenuToggle",
  props: {
    /**
     * 表示するタイトル
     */
    title: {
      type: String,
      default: ""
    },
    unreadCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isOpen: false
    };
  },

  methods: {
    clickToggle() {
      this.$router.push({ name: "CrlyNews" });
      this.$emit("close");
    },
    openToggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/btn/sideMenuToggle.scss";
</style>
